import { render, staticRenderFns } from "./CookieBanner.vue?vue&type=template&id=36210a5b&"
import script from "./CookieBanner.vue?vue&type=script&lang=js&"
export * from "./CookieBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36210a5b')) {
      api.createRecord('36210a5b', component.options)
    } else {
      api.reload('36210a5b', component.options)
    }
    module.hot.accept("./CookieBanner.vue?vue&type=template&id=36210a5b&", function () {
      api.rerender('36210a5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwg/js/components/CookieBanner.vue"
export default component.exports